import { render, staticRenderFns } from "./TagManagement.vue?vue&type=template&id=6ac2ba2a&scoped=true&"
import script from "./TagManagement.vue?vue&type=script&lang=ts&"
export * from "./TagManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2ba2a",
  null
  
)

export default component.exports